<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-bind="attrs"
          v-on="on"
          :color="!disabled ? 'indigo white--text' : 'indigo lighten-4 white--text'"
      >{{`${period} ${period != 1 ? `weeks`: `week`}`}} to {{dateEnd}}</v-btn>
    </template>
    <v-date-picker
        v-model="dateEnd"
        :allowed-dates="allowedWeeksStart"
    >
      <v-layout d-flex flex-column>
        <v-select
          dense
          v-model="period"
          :items="getWeeks"
          item-text="label"
          item-value="value"
          label="Weeks"
          outlined
        ></v-select>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="click"
          class="ml-auto"
        >
          Apply
        </v-btn>
      </v-layout>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
    props: {
      weeks: {
        type: String
      },
      weeksEnd: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
    return {
      menu: false,
      period: this.weeks,
      dateEnd: this.weeksEnd,
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 99 weeks',
      },
    }
  },
  watch:{
    weeks(){
      this.period = this.weeks
    },
    weeksEnd(){
      this.dateEnd = this.weeksEnd
    }
  },
  methods: {
      click() {
        sessionStorage.setItem('weeksEnd', this.dateEnd)
        sessionStorage.setItem('period', this.period)

        this.$emit('getDates', { period: this.period, weeksEnd: this.dateEnd})
        this.menu = false
      },
      allowedWeeksStart(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      }, 
  },
  computed: {
    getWeeks() {
      const arr = []
      for (let i = 1; i < 100; i++) {
        arr.push({label: `${i} ${(i > 1) ? `weeks`: `week`}`, value: i.toString()})
      }
      return arr
    }
  }
};
</script>

<style>
</style>